import { useStore } from 'src/contexts/StoreContext';

export function useActiveProjectPrices(): {
  estimatePrice: number | undefined;
  originalPrice: number | undefined;
} {
  const {
    project: { activeProject, productConfigurationId },
  } = useStore();

  let estimatePrice = activeProject?.estimate;
  let originalPrice = activeProject?.original;

  // in the scenario of the "quadretti adesivi" we need to use the price from the frameConfigStepsData
  const frameConfigStepData = activeProject?.frameConfigStepsData?.find(
    step => step.productConfigurationId === productConfigurationId,
  );
  if (frameConfigStepData) {
    const { fullPrice, price } = frameConfigStepData;
    originalPrice = !!fullPrice && !!price && price !== fullPrice ? fullPrice : undefined;
    estimatePrice = price;
  }

  return {
    estimatePrice,
    originalPrice,
  };
}
